<app-admin-dashboard>
  <div class="card">
    <div class="header-card pt-0 mb-3">
      <div class="w-3 container-title">
        <h1 class="text-xl font-medium text-800">
          {{'AdminUsersManagement.PageTitle' | translate}}
        </h1>
      </div>
      <div class="w-5 flex align-items-center justify-content-start flex-wrap">
        <span class="p-input-icon-left justify-content-start flex w-10">
          <i class="pi pi-search custom-input-icon"></i>
          <input [(ngModel)]="searchTerm" (input)="onFilter()" type="text" pInputText
            placeholder="{{'AdminUsersManagement.SearchText' | translate}}"
            class="p-inputtext-sm custom-input bg-form w-full" />
        </span>
      </div>
      <div class="md:w-4 flex align-items-center justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-end pr-4">
          <p-button
            label="{{'AdminUsersManagement.InviteToFruztyButton' | translate}}" icon="pi pi-user"
            (onClick)="onOpenSendInvitationCodeDialog()"
            styleClass="p-button-secondary"
            class="custom-text-button"/>
        </div>
        <div class="flex align-items-center justify-content-end">
          <p-button
            label="{{'AdminUsersManagement.NewButton' | translate}}" icon="pi pi-plus"
            (onClick)="onOpenUserCreateDialog()"
            class="custom-text-button"/>
        </div>
      </div>
    </div>

    <div>
      <p-table [value]="filteredProfiles"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [loading]="loading"
        class="custom-table">
        <ng-template pTemplate="header">
          <tr>
            <th id="user-id">
              <div class="flex justify-content-center align-items-center">
                {{'AdminUsersManagement.Table.IdColumn' | translate}}
              </div>
            </th>
            <th id="contact-name">
              <div class="flex align-items-center">
                {{'AdminUsersManagement.Table.ContactNameColumn' | translate}}
              </div>
            </th>
            <th id="email">
              <div class="flex align-items-center">
                {{'AdminUsersManagement.Table.EmailColumn' | translate}}
              </div>
            </th>
            <th id="role">
              <div class="flex align-items-center">
                {{'AdminUsersManagement.Table.RoleColumn' | translate}}
              </div>
            </th>
            <th id="company">
              <div class="flex align-items-center">
                {{'AdminUsersManagement.Table.CompanyColumn' | translate}}
              </div>
            </th>
            <th id="status">
              <div class="flex justify-content-center align-items-center">
                {{'AdminUsersManagement.Table.StatusColumn' | translate}}
              </div>
            </th>
            <th id="details">
              <div class="flex justify-content-center align-items-center">
                {{'AdminUsersManagement.Table.DetailsColumn' | translate}}
              </div>
            </th>
            <th id="actions">
              <div class="flex justify-content-center align-items-center">
                {{'AdminUsersManagement.Table.ActionsColumn' | translate}}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-profile>
          <tr>
            <td>
              <div class="flex justify-content-center align-items-center">{{profile.id}}</div>
            </td>
            <td>
              <div class="flex align-items-center">{{profile.contactName}}</div>
            </td>
            <td>
              <div class="flex align-items-center">{{profile.contactEmail}}</div>
            </td>
            <td>
              <div class="flex align-items-center">{{getProfileTypeName(profile.type)}}</div>
            </td>
            <td>
              <div class="flex align-items-center">{{profile.companyName}}</div>
            </td>
            <td>
              <div class="flex justify-content-center align-items-center">
                <span class="status-tag"
                  [ngClass]="{'active': profile.isActive, 'inactive': !profile.isActive}">
                  {{profile.isActive ?
                    ('AdminUsersManagement.Table.ActiveText' | translate) :
                    ('AdminUsersManagement.Table.InactiveText' | translate)
                  }}
                </span>
              </div>
            </td>
            <td>
              <div class="flex justify-content-center align-items-center">
                <p-button
                  label="{{'AdminUsersManagement.Table.ImportersButton' | translate}}"
                  *ngIf="profile.type == 1"
                  (onClick)="onOpenImportersAssociationDialog(profile)"
                  styleClass="p-button-outlined p-button-secondary"
                  class="custom-text-button secondary-filled"/>
              </div>
            </td>
            <td>
              <div class="flex justify-content-end align-items-end gap-3">
                <p-button
                  pTooltip="{{'AdminUsersManagement.Table.SeeButton' | translate}}"
                  tooltipPosition="bottom"
                  (onClick)="onOpenUserDetailDialog(profile)"
                  [disabled]="!profile.isActive"
                  icon="pi pi-eye"
                  class="custom-button-icon green-btn"/>

                <p-button
                  pTooltip="{{'AdminUsersManagement.Table.EditButton' | translate}}"
                  tooltipPosition="bottom"
                  (onClick)="onOpenUserEditDialog(profile)"
                  [disabled]="!profile.isActive"
                  icon="pi pi-pencil"
                  class="custom-button-icon blue-btn"/>

                <p-button
                  pTooltip="{{'AdminUsersManagement.Table.AssignConsigneeNotifierButton' | translate}}"
                  tooltipPosition="bottom"
                  (onClick)="onOpenConsigneeNotifierAssociationDialog(profile)"
                  [disabled]="!profile.isActive"
                  icon="pi pi-users"
                  class="custom-button-icon green-btn"
                  />

                <p-button
                  pTooltip="{{'AdminUsersManagement.Table.AdminLoginButton' | translate}}"
                  tooltipPosition="bottom"
                  (onClick)="adminLogin(profile)"
                  [disabled]="!profile.isActive"
                  icon="pi pi-sign-in"
                  class="custom-button-icon green-btn"
                  />

                <p-button
                  [pTooltip]="profile.isActive ?
                    ('AdminUsersManagement.Table.DeactivateButton' | translate) :
                    ('AdminUsersManagement.Table.ActivateButton' | translate)"
                  tooltipPosition="bottom"
                  (onClick)="toogleIsActive(profile)"
                  [icon]="profile.isActive ? 'pi pi-user-minus' : 'pi pi-user-plus'"
                  class="custom-button-icon"
                  [ngClass]="{
                    'red-btn': profile.isActive,
                    'blue-btn': !profile.isActive
                  }"/>

                <p-button
                  [disabled]="!(profile.validationToken != null && profile.validationToken != '') || !profile.isActive"
                  pTooltip="{{'AdminUsersManagement.Table.ResendInvitationButton' | translate}}"
                  tooltipPosition="left"
                  (onClick)="sendValidationToken(profile.id)"
                  icon="pi"
                  class="custom-button-icon blue-btn">
                  <span class="material-symbols-outlined">forward_to_inbox</span>
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</app-admin-dashboard>


<p-confirmDialog
  rejectButtonStyleClass="p-button-outlined"
  [style]="{width: '35vw'}"/>

<p-dialog
  header="{{'AdminUsersManagement.InvitationCode.DialogTitle' | translate}}"
  [(visible)]="showSendInvitationCodeDialog"
  [style]="{width: '70%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">
  <div *ngIf="showSendInvitationCodeDialog">
    <app-admin-invitation-code
      (closeDialog)="onCloseSendInvitationCodeDialog()"
    />
  </div>
</p-dialog>

<p-dialog
  header="{{'AdminUsersManagement.CreateEditUser.CreateUserTitle' | translate}}"
  [(visible)]="showUserCreateDialog"
  [style]="{width: '70%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">
  <div *ngIf="showUserCreateDialog" class="container-panel">
    <app-admin-create-user
      (closeDialog)="onCloseUserCreateDialog($event)"
      [mockImporter]="mockImporter"
      [exporterRelation]="exporterRelation"

    />
  </div>
</p-dialog>

<p-dialog
  header="{{'AdminUsersManagement.CreateEditUser.UserDetailTitle' | translate}}"
  [(visible)]="showUserDetailDialog"
  [style]="{width: '70%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">

  <div *ngIf="showUserDetailDialog">
    <app-admin-user-detail
      [profileId]="selectedProfile.id"
      (closeDialog)="onCloseUserDetailDialog()"
    />
  </div>
</p-dialog>

<p-dialog
  header="{{'AdminUsersManagement.CreateEditUser.EditUserTitle' | translate}}"
  [(visible)]="showUserEditDialog"
  [style]="{width: '70%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">

  <div *ngIf="showUserEditDialog">
    <app-admin-edit-user
      [profileId]="selectedProfile.id"
      (closeDialog)="onCloseUserEditDialog($event)"
    />
  </div>
</p-dialog>

<p-dialog
  header="{{'AdminUsersManagement.ExporterAssociation.DialogTitle' | translate}}"
  [(visible)]="showImportersAssociationDialog"
  [style]="{width: '80%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">

  <div *ngIf="showImportersAssociationDialog">
    <div class="flex justify-content-end">
      <p-button styleClass="p-button-sm" (click)="createImporterRelation(selectedProfile)"
      label="Crear importador"
      >
      </p-button>
    </div>
    <app-admin-exporter-importers-page
      [exporterProfile]="selectedProfile"
      (closeDialog)="onCloseImportersAssociationDialog()"
    />
  </div>
</p-dialog>

<p-dialog
  header="{{'AdminUsersManagement.Table.AssignConsigneeNotifierButton' | translate}}"
  [(visible)]="showConsigneeNotifierAssociationDialog"
  [style]="{width: '80%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">

  <div *ngIf="showConsigneeNotifierAssociationDialog">
    <app-admin-assign-consignee-notifier-user
      [profileId]="selectedProfile.id"
      (closeDialog)="onCloseConsigneeNotifierAssociationDialog()"
    />
  </div>
</p-dialog>
